export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/components/errors-pages/Error503.tsx"